import React from 'react'

const Loader = () => {
    return (
        <div>
            <div className="loader"><br></br>
                <h1>DECOWEATHER</h1>
                Finding best details for you...
            </div>
        </div>
    )
}

export default Loader
